export default __webpack_public_path__ + "static/media/page-loader.5ffdd6e9.svg";